export default {
  dark: '0px 4px 4px rgba(0, 0, 0, 0.15), 0px 4px 14px rgba(0, 0, 0, 0.16)',
  light: '0px 4px 4px rgba(0, 0, 0, 0.06), 0px 4px 14px rgba(0, 0, 0, 0.08)',
};
